import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BankService {

  base_url: string | undefined

  headerObject = {
    'Authorization': sessionStorage.getItem('token')!,
    'X-TENANT-ID': 'hr'
  };
  headers = new HttpHeaders(this.headerObject);
  headersBh = new HttpHeaders({ ...this.headerObject, 'X-TENANT-ID': '101' });
  requestOptions: any = {};

  constructor(private http: HttpClient) {

    this.base_url = environment.url;
    this.requestOptions = {
      headers: this.headers
    };

  }

  getPendingList(payload: any = { applicationType: 1 }, xTenantId: any = '12') {
    let headersBh = new HttpHeaders({ ...this.headerObject, 'X-TENANT-ID': xTenantId });
    const requestOptions = {
      headers: headersBh
    };
    const queryString = Object.entries(payload)
      .filter(([key, value]) => value)
      .map(([key, value]: any) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
      .join('&');;

    return this.http.get(`${this.base_url}bankloanmis/bank/application-list?${queryString}`, requestOptions)
  }

  getMarketState(payload: any = { applicationType: 1 }) {

    const requestOptions = {
      headers: this.headersBh
    };

    const queryString = Object.entries(payload)
      .filter(([key, value]) => value)
      .map(([key, value]: any) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
      .join('&');
    if (payload.applicationTab === 1 || payload.applicationTab === 5 || payload.applicationTab === 4) {
      return this.http.get(`${this.base_url}bankloanmis/bank/state-appcount?${queryString}`, requestOptions)
    }
    else {
      return this.http.get(`${this.base_url}bankloanmis/master/statewise-appcount?${queryString}`, requestOptions)
    }
    // 
  }

  getCensusList(payload: any = { applicationType: 1 }, endPoint: string = 'bankloanmis/bank/districtlist-marketplace', xTenantId: any = 'bh') {
    let headersBh = new HttpHeaders({ ...this.headerObject, 'X-TENANT-ID': xTenantId });
    const requestOptions = {
      headers: headersBh
    };

    const queryString = Object.entries(payload)
      .filter(([key, value]) => value)
      .map(([key, value]: any) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
      .join('&');;

    return this.http.get(`${this.base_url}${endPoint}?${queryString}`, requestOptions)
  }

  rejectLoan(xTenantId: any = '', payload: any) {
    let headersBh = new HttpHeaders({ ...this.headerObject, 'X-TENANT-ID': xTenantId });
    const requestOptions = {
      headers: headersBh
    };


    return this.http.post(
      `${this.base_url}bankloanmis/bank/reject-application`, payload);
  }

  sanctionLoan(payload: any) {
    // let headersBh = new HttpHeaders({...this.headerObject, 'X-TENANT-ID':xTenantId });
    // const requestOptions = {
    //   headers: headersBh
    // };


    return this.http.post(
      `${this.base_url}bankloanmis/bank/sanction-application`, payload,
      {}
    );
  }

  pullLoan(xTenantId: any = '', shgLoanId: any) {
    let headersBh = new HttpHeaders({ ...this.headerObject, 'X-TENANT-ID': xTenantId });
    const requestOptions = {
      headers: headersBh
    };


    return this.http.post(
      `${this.base_url}bankloanmis/bank/application-pull?shgLoanId=${shgLoanId}`, '',
      requestOptions
    );
  }

  pushLoan(xTenantId: any = '', shgLoanId: any) {
    let headersBh = new HttpHeaders({ ...this.headerObject, 'X-TENANT-ID': xTenantId });
    const requestOptions = {
      headers: headersBh
    };


    return this.http.post(
      `${this.base_url}bankloanmis/bank/application-pushback?shgLoanId=${shgLoanId}`, '',
      requestOptions
    );
  }

  reviewLoan(xTenantId: any = '', shgLoanId: any) {
    let headersBh = new HttpHeaders({ ...this.headerObject, 'X-TENANT-ID': xTenantId });
    const requestOptions = {
      headers: headersBh
    };


    return this.http.post(
      `${this.base_url}bankloanmis/bank/application-review?shgLoanId=${shgLoanId}`, '',
      requestOptions
    );
  }
}
